/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-face-dizzy': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm0 16.25a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm5.256-10.625l-.881-.881-1.25 1.25-1.25-1.25-.881.881 1.25 1.25-1.25 1.25.881.881 1.25-1.25 1.25 1.25.881-.881-1.25-1.25 1.25-1.25zm-6.25 0l-.881-.881-1.25 1.25-1.25-1.25-.881.881 1.25 1.25-1.25 1.25.881.881 1.25-1.25 1.25 1.25.881-.881-1.25-1.25 1.25-1.25zm.994 5a1.875 1.875 0 100 3.75 1.875 1.875 0 000-3.75z"/>'
  }
})
